import { Card, Modal } from "@mui/material";
import React from "react";
import DriverDepositView from "./DriverDepositView";

type CreateDepositModalProps = {
  handleClose: () => void;
  isOpen: boolean;
  isTransportDriver: boolean;
  name: string;
  phone: string;
  id: number;
  onSuccess: () => void;
};

const CreateDepositModal: React.FC<CreateDepositModalProps> = ({
  handleClose,
  isOpen,
  name,
  phone,
  id,
  isTransportDriver,
  onSuccess,
}) => {
  console.log(
    `CreateDepositModal rendered with isTransportDriver: ${isTransportDriver}, name: ${name}, phone: ${phone}, id: ${id}`,
  );

  return (
    <>
      <Modal
        open={isOpen}
        onClose={handleClose}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card elevation={4} sx={{ padding: 2, minWidth: 600 }}>
          <DriverDepositView
            isTransportDriver={isTransportDriver}
            onComplete={onSuccess}
            name={name}
            phone={phone}
            id={id}
          />
        </Card>
      </Modal>
    </>
  );
};

export default CreateDepositModal;
